<div class="tableComponent row">
    <div class="col-lg-12">
        <app-table tableTitle="{{ 'pim.elementTypes.title' | translate }} : {{ table.length }} {{ (table.length > 1 ? 'general.results' : 'general.result') | translate }}" [table]="table" [columns]="columns" [actions]="actions" (action)="onActionClick($event)"></app-table>
    </div>
</div>
